var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown max-w-full",class:{ 'is-active': _vm.isActive }},[_c('div',{staticClass:"dropdown-trigger max-w-full",on:{"click":_vm.toggle}},[_vm._t("trigger")],2),_c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"dropdown-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }